import React, { createContext, useContext, useState, useEffect } from 'react';

const PreferencesContext = createContext();

export const usePreferences = () => {
  const context = useContext(PreferencesContext);
  if (!context) {
    throw new Error('usePreferences must be used within PreferencesProvider');
  }
  return context;
};

export const PreferencesProvider = ({ children }) => {
  const [scriptMode, setScriptMode] = useState(localStorage.getItem('scriptMode') || null);
  const [audience, setAudience] = useState(localStorage.getItem('audience') || null);

  useEffect(() => {
    if (scriptMode) {
      localStorage.setItem('scriptMode', scriptMode);
    }
  }, [scriptMode]);

  useEffect(() => {
    if (audience) {
      localStorage.setItem('audience', audience);
    }
  }, [audience]);

  const resetPreferences = () => {
    setScriptMode(null);
    setAudience(null);
    localStorage.removeItem('scriptMode');
    localStorage.removeItem('audience');
  };

  return (
    <PreferencesContext.Provider value={{ scriptMode, setScriptMode, audience, setAudience, resetPreferences }}>
      {children}
    </PreferencesContext.Provider>
  );
};